import { MarketingPreferencesFormValue } from '../../models/marketing-preferences/marketing-preferences-form-value.type';

export const mockMarketingPreferencesFormValue: MarketingPreferencesFormValue =
  {
    marketingPreferenceEmail: true,
    marketingPreferencePost: true,
    marketingPreferenceTelephone: true,
  };
